var date = new Date();
date.setDate(7);
date.setFullYear(2016);
date.setMonth(9);

const EVENTS = {
 "15" : [{
   name: 'Friends of Scouting',
   date: date,
   description: "The annual FOS Campaign focuses on raising a significant portion of this budget through families who participate in Scouting.",
   link: 'http://cflscouting.org/support-scouting/friends-of-scouting/',
 },
 {
   name: 'Boy Scouts Golf Classic',
   date: new Date(),
   description: 'description goes here',
   link: 'http://google.com',
 },
 {
   name: 'Sporting Clays Invitational',
   date: new Date(),
   description: 'description goes here',
   link: 'http://google.com',
 },
 {
   name: 'Space Coast Lighfest',
   date: new Date(),
   description: 'description goes here',
   link: 'http://google.com',
 }],
 "16": [{
   name: 'Club Halloween Weekends @ Camp La-No-Che',
   date: date,
   description: "In October, Camp La-No-Che is possessed with a haunted house, haunted trails, fun crafts, BB's, Archery, and more ghoulish fun! Bring your costume for the costume parade Saturday night!",
   link: 'http://cflscouting.org/',
 },
 {
   name: 'Tiger Growl @ Camp La-No-Che',
   date: new Date(),
   description: 'description goes here',
   link: 'http://google.com',
 },
 {
   name: 'Club Holiday Weekend @ Camp La-No-Che',
   date: new Date(),
   description: 'description goes here',
   link: 'http://google.com',
 },
 {
   name: 'Webelos to Scout Transition @ Camp La-No-Che',
   date: new Date(),
   description: 'description goes here',
   link: 'http://google.com',
 }
]};

const templateUrl = require('./../views/cause-events.html');

function directive(Calendar, $sce) {
  return {
    restrict: 'EA',
    scope: true,
    templateUrl,
    link: function(scope, el, attrs) {

      console.log('the date is', scope, attrs);
      scope.events = [];
      scope.eventDetail = {};
      scope.showEvent  = function($index) {
        scope.eventDetail = scope.events[$index];
      };

      scope.eventDetail = scope.events[0];

      Calendar.getEvents(attrs.calendarId).then(function(res) {
        var now = new Date();
        if(!res) {
          return [];
        }
        scope.events = res.filter(function(event) {
          return (event &&
            event.start &&
            (event.start.dateTime || event.start.date) &&
            new Date(event.start.dateTime || event.start.date) > now );
        })
        .map(function(_event) {
          var event = {};
          event.name = _event.summary;
          if(_event.start) {
            event.date = _event.start.dateTime || _event.start.date;
          }

          var description = _event.description || '';

          var start = description.indexOf('^');
          var end = description.lastIndexOf('^');
          var link = description.substr(start, end);

          event.description = description.replace(link, '').replace(/(\r\n|\n|\r)/g,"<br />");
          event.link = link.replace(/\^/g, '');
          return event;
        })
        .sort(function(a,b) {
          return new Date(a.date) > new Date(b.date);
        })
        .slice(0, 4)
        ;

        scope.eventDetail = scope.events[0];

      });
    }
  };
}

export default directive;



// WEBPACK FOOTER //
// ./js/containers/causePortal/directives/causeEvents.js